import styled from "styled-components";



export const VerifyAchCardContainer = styled.div`
  min-width: 450px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

export const VerifyAchCardTitle = styled.div`
  font-size: 20px;
  color: #002E5C;
  font-weight: 700;
`;


export const VerifyAchCardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
`

export const VerifyAchCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const VerifyAchCardText = styled.div`
  font-size: 16px;
  color: #002E5C;
  font-weight: 400;
  width: 90%;
`

export const VerifyAchCardOlList = styled.ol`

`

export const VerifyAchCardOlItem = styled.li`
  font-size: 16px;
  color: #002E5C;
  font-weight: 400;
  width: 90%;
`